import React, { useState } from 'react';
import axios from 'axios';
import { Link, Navigate } from 'react-router-dom';
import Loader from '../lib/components/Loader';

// this is sloppy but it'll do
const LoginForm = ({ loadingUserData, userData, updateUserData }) => {    
    const [formData, setFormData] = useState({
        identifier: '',
        password: ''
    });
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setSubmitting(true);
        try {
            const response = await axios.post('/api/v1/user/login', formData);
            updateUserData(response.data);
        } catch (error) {
            if (error.response?.status === 401) {
                setErrors({ auth: 'Invalid username or password' });
                return;
            }
            setErrors({ other: 'An error occurred while logging in' });
        } finally {
            setSubmitting(false);
        }
    };

    if (loadingUserData) {
        return <Loader />;
    }

    if (userData.username) {
        return <Navigate to="/myTeam" />;
    }

    return (
        <div>
            <h2>Sign In</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="identifier">Username or Email:</label>
                    <input type="text" id="identifier" name="identifier" className="form-control" value={formData.identifier} onChange={handleChange} />
                </div>
                <div className="mb-2">
                    <label htmlFor="password">Password:</label>
                    <input type="password" id="password" name="password" className="form-control" value={formData.password} onChange={handleChange} />
                </div>
                {Object.keys(errors).length > 0 && (<div class="alert alert-danger">{Object.values(errors).join(', ')}</div>)}
                <button className="btn btn-primary" type="submit" disabled={submitting}>{submitting ? 'Signing in…' : 'Sign in'}</button>
                <div className="mt-2">
                    <Link to="/forgot-password">Forgot password?</Link>
                </div>
                <div className="mt-2">
                    <Link to="/login-link">Log in with an email link instead</Link>
                </div>
                <div className="text-muted mt-4">
                    Need an account? <Link to="/signup">Sign up here.</Link>
                </div>
            </form>
        </div>
    );
};

export default LoginForm;